export const selectExistsInWishList = (itemId) => (state) =>
    state.items?.wishListItemIds.includes(itemId);
